import SelectionStatus from 'portfolio/components/SelectionStatus';
import React, { useRef } from 'react';

import EstimatedTradeCostComparisonHelp from '../help/EstimatedTradeCostComparisonHelp';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { EstimatedTradeCostTitle } from 'widgets/estimatedTradeCost/widget/components/toolbar/EstimatedTradeCostTitle';
import {
    GridApi,
    GridExportButton,
    ToolbarIcon,
} from '@instinet-analytics/semantic-ui-components';
import { EstimatedTradeCostComparisonWidgetSettings } from 'widgets/estimatedTradeCost/widget-comparison/components/settings/EstimatedTradeCostComparisonWidgetSettings';
import { doNothing } from 'utils/general';
import { OnSaveHandler } from 'widgets/WidgetToolbar/WidgetSettingsButton';
import EstimatedTradeCostComparisonColumnPicker from 'widgets/estimatedTradeCost/widget-comparison/components/grid/EstimatedTradeCostComparisonColumnPicker';
import { EstimatedTradeCostComparisonDebugModal } from '../debug-modal/EstimatedTradeCostComparisonDebugModal';
import { StreamMessage } from 'utils/messages/StreamMessage';

export default function EstimatedTradeCostComparisonToolbar({
    showRefresh,
    hideSelectionWarning,
    messages,
    mustShow,
    onRerunQuery,
    gridApi,
}: {
    gridApi?: GridApi;
    hideSelectionWarning: boolean;
    showRefresh: boolean;
    messages: StreamMessage[];
    mustShow: boolean;
    onRerunQuery: () => void;
}) {
    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const onSaveHandler = useRef<OnSaveHandler>(doNothing);

    const setOnSaveHander = (handler: OnSaveHandler) => {
        onSaveHandler.current = handler;
    };

    const onSave = () => {
        return onSaveHandler.current();
    };

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection || mustShow}>
            <div className="EstimatedTradeCostComparisonToolbar panel-header">
                <div className="toolbar">
                    <EstimatedTradeCostTitle />

                    {!hideSelectionWarning && (
                        <SelectionStatus
                            widgetName="Pre-Trade Cost Comparison Widget"
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                        />
                    )}
                </div>
                <WidgetToolbar
                    preceedingItems={<EstimatedTradeCostComparisonHelp />}
                    settingsHeader="Pre-Trade Cost Comparison Settings"
                    settingsBody={
                        <EstimatedTradeCostComparisonWidgetSettings
                            handleOnSave={setOnSaveHander}
                        />
                    }
                    settingsClassName="EstimatedTradeCostComparisonWidgetSettingsModal"
                    settingsAllowCancel={true}
                    settingsSaveText={'OK'}
                    settingsOnSave={onSave}
                    messages={hasValidSelection ? messages : []}
                    fixedItems={
                        <>
                            <EstimatedTradeCostComparisonDebugModal />
                            <GridExportButton
                                csvFileName={'EstimatedTradeCostComparison'}
                                gridApi={gridApi}
                            />
                            {showRefresh && (
                                <ToolbarIcon
                                    className="refresh-button"
                                    name="refresh"
                                    tooltip="Refresh"
                                    onClick={onRerunQuery}
                                />
                            )}
                            <EstimatedTradeCostComparisonColumnPicker />
                        </>
                    }
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
